import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";
import { adminFetch } from "../utils/adminAuth";

export default function AdminServiceInquiries() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [replies, setReplies] = useState({});
    const [savingId, setSavingId] = useState(null);
    const [search, setSearch] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const load = () => {
        setLoading(true);
        adminFetch(`${API_BASE}/api/get_service_enquiries.php`)
            .then((r) => r.json())
            .then((data) => { if (data.success) setRows(data.enquiries); })
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    useEffect(() => {
        if (!window.bootstrap) return undefined;
        const elements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltips = [...elements].map((element) => new window.bootstrap.Tooltip(element));
        return () => tooltips.forEach((tooltip) => tooltip.dispose());
    }, [rows, currentPage, search, itemsPerPage]);

    const filteredRows = rows.filter((row) => {
        const query = search.toLowerCase();
        return [row.category, row.full_name, row.mobile, row.message, row.status]
            .some((value) => String(value || "").toLowerCase().includes(query));
    });
    const totalPages = Math.ceil(filteredRows.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const pageRows = filteredRows.slice(startIndex, startIndex + itemsPerPage);

    useEffect(() => {
        if (currentPage > totalPages && totalPages > 0) setCurrentPage(1);
    }, [currentPage, totalPages]);

    const respond = async (id, status) => {
        setSavingId(id);
        try {
            const res = await adminFetch(`${API_BASE}/api/reply_service_enquiry.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id, status, admin_reply: replies[id] ?? "" }),
            });
            const data = await res.json();
            if (data.success) load();
        } finally {
            setSavingId(null);
        }
    };

    const initial = (name) => (name ? name.trim().charAt(0).toUpperCase() : "?");

    return (
        <div className="service-inquiries-page">
            <style>{`
                .service-inquiries-page { color: #0b1220; padding: 4px; }
                .service-inquiries-page .dn-hero { display:flex; justify-content:space-between; align-items:center; gap:12px; background:linear-gradient(135deg,#e8f0ff,#fefefe); border-left:6px solid #4a90e2; border-radius:14px; padding:18px 22px; margin-bottom:18px; box-shadow:0 4px 14px rgba(0,0,0,.05); }
                .service-inquiries-page .dn-hero h1 { font-size:1.2rem; }
                .service-inquiries-page .dn-hero p { color:#6b7280; font-size:.9rem; }
                .service-inquiries-page .dn-count { text-align:center; background:#eef3ff; border-radius:12px; padding:8px 18px; }
                .service-inquiries-page .dn-count strong { display:block; font-size:1.6rem; line-height:1; color:#2563eb; }
                .service-inquiries-page .dn-count span { font-size:.72rem; color:#6b7280; text-transform:uppercase; letter-spacing:.05em; }
                .service-inquiries-page .dn-card { background:#fff; border-radius:16px; box-shadow:0 6px 20px rgba(0,0,0,.06); overflow:hidden; }
                .service-inquiries-page .dn-toolbar { display:flex; justify-content:space-between; align-items:center; gap:12px; padding:16px 18px; border-bottom:1px solid #f0f2f5; flex-wrap:wrap; }
                .service-inquiries-page .dn-select { border:1px solid #dfe3e8; border-radius:8px; padding:6px 10px; font-size:14px; background:#fff; }
                .service-inquiries-page .dn-search { display:flex; align-items:center; gap:8px; border:1px solid #dfe3e8; border-radius:24px; padding:7px 14px; min-width:240px; }
                .service-inquiries-page .dn-search i { color:#9aa1a9; }
                .service-inquiries-page .dn-search input { border:0; outline:0; font-size:14px; width:100%; background:transparent; }
                .service-inquiries-page .dn-table { width:100%; border-collapse:separate; border-spacing:0; }
                .service-inquiries-page .dn-table th { background:#f7f9fc; color:#6b7280; font-size:12px; text-transform:uppercase; letter-spacing:.04em; padding:12px 16px; border-bottom:1px solid #eef0f3; white-space:nowrap; }
                .service-inquiries-page .dn-table td { padding:14px 16px; border-bottom:1px solid #f3f5f8; vertical-align:middle; font-size:14px; }
                .service-inquiries-page .dn-table tbody tr:hover { background:#f7faff; }
                .service-inquiries-page .dn-avatar { width:40px; height:40px; flex:0 0 40px; border-radius:10px; background:linear-gradient(135deg,#4a90e2,#5fb3ff); color:#fff; display:flex; align-items:center; justify-content:center; font-weight:700; }
                .service-inquiries-page .inquiry-category { background:#eef4ff; color:#2563eb; border:1px solid #dbe7ff; }
                .service-inquiries-page .status-pending { background:#fff4e0; color:#b45309; }
                .service-inquiries-page .status-replied { background:#e7f8ef; color:#15803d; }
                .service-inquiries-page .status-closed { background:#f1f3f5; color:#6b7280; }
                .service-inquiries-page .form-control { border-color:#d6dbe1; border-radius:8px; }
                .service-inquiries-page .form-control:focus { border-color:#2563eb; box-shadow:0 0 0 .2rem rgba(37,99,235,.12); }
                .service-inquiries-page .dn-act { width:34px; height:34px; border:0; border-radius:9px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer; transition:.2s; }
                .service-inquiries-page .dn-act:hover { transform:translateY(-2px); }
                .service-inquiries-page .dn-act-green { background:#e7f8ef; color:#15803d; }
                .service-inquiries-page .dn-act-gray { background:#f1f3f5; color:#6b7280; }
                .service-inquiries-page .dn-foot { display:flex; justify-content:space-between; align-items:center; gap:12px; padding:14px 18px; flex-wrap:wrap; }
                .service-inquiries-page .dn-pager { display:flex; gap:6px; }
                .service-inquiries-page .dn-pager button { min-width:36px; height:36px; border:1px solid #e3e7ee; background:#fff; border-radius:9px; color:#2563eb; font-weight:600; cursor:pointer; }
                .service-inquiries-page .dn-pager button.active { background:#2563eb; color:#fff; }
                .service-inquiries-page .dn-pager button:disabled { opacity:.45; cursor:not-allowed; }
                @media (max-width:640px) { .service-inquiries-page .dn-search { min-width:100%; } .service-inquiries-page .dn-hero { align-items:flex-start; flex-direction:column; } }
            `}</style>
            <div className="dn-hero">
                <div>
                    <h1 className="fw-bold mb-1"><i className="bi bi-headset me-2 text-primary"></i>Service Inquiries</h1>
                    <p className="mb-0">
                Enquiries submitted from the category tiles on the homepage (e.g. "Plumber", "Electrician").
                    </p>
                </div>
                <div className="dn-count"><strong>{rows.length}</strong><span>Total</span></div>
            </div>

            <div className="dn-card">
                <div className="dn-toolbar">
                    <div className="d-flex align-items-center gap-2">
                        <span className="text-muted small">Show</span>
                        <select className="dn-select" value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
                            {[10, 50, 100].map((count) => <option key={count} value={count}>{count}</option>)}
                        </select>
                        <span className="text-muted small">entries</span>
                    </div>
                    <div className="dn-search">
                        <i className="bi bi-search"></i>
                        <input type="text" placeholder="Search name, mobile, category..." value={search} onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }} />
                    </div>
                </div>
                <div className="table-responsive">
                    {loading ? (
                        <div className="p-3">Loading...</div>
                    ) : filteredRows.length === 0 ? (
                        <div className="p-3 text-secondary">No inquiries yet.</div>
                    ) : (
                            <table className="dn-table">
                                <thead className="table-light">
                                    <tr><th>#</th><th>Requester</th><th>Category</th><th>Message</th><th>Status</th><th>Reply</th><th>Received</th><th className="text-center">Actions</th></tr>
                                </thead>
                                <tbody>
                                    {pageRows.map((r, index) => (
                                        <tr key={r.id}>
                                            <td className="text-muted">{startIndex + index + 1}</td>
                                            <td><div className="d-flex align-items-center gap-2"><div className="dn-avatar">{initial(r.full_name)}</div><div><strong>{r.full_name}</strong><br /><small className="text-muted"><i className="bi bi-telephone-fill text-success me-1"></i>{r.mobile}</small></div></div></td>
                                            <td><span className="badge inquiry-category" title={`Service category: ${r.category}`}>{r.category}</span></td>
                                            <td className="small" style={{ maxWidth: 220, whiteSpace: "pre-wrap" }}>{r.message || <span className="text-secondary">—</span>}</td>
                                            <td title={`Inquiry status: ${r.status}`}>
                                                <span className={`badge status-${r.status || "closed"}`}>{r.status}</span>
                                            </td>
                                            <td style={{ minWidth: 200 }}>
                                                <textarea
                                                    className="form-control form-control-sm"
                                                    rows="2"
                                                    placeholder="Type a reply..."
                                                    defaultValue={r.admin_reply || ""}
                                                    title="Write an admin reply"
                                                    onChange={(e) => setReplies((n) => ({ ...n, [r.id]: e.target.value }))}
                                                />
                                            </td>
                                            <td className="text-secondary small" style={{ whiteSpace: "nowrap" }}>{r.created_at || "—"}</td>
                                            <td>
                                                <div className="d-flex justify-content-center gap-2" role="group" aria-label={`Actions for inquiry from ${r.full_name}`}>
                                                    <button
                                                        className="dn-act dn-act-green"
                                                        data-bs-toggle="tooltip"
                                                        title="Save reply and mark as replied"
                                                        disabled={savingId === r.id}
                                                        onClick={() => respond(r.id, "replied")}
                                                    >
                                                        <i className="bi bi-send-fill"></i>
                                                    </button>
                                                    <button
                                                        className="dn-act dn-act-gray"
                                                        data-bs-toggle="tooltip"
                                                        title="Close this inquiry"
                                                        disabled={savingId === r.id}
                                                        onClick={() => respond(r.id, "closed")}
                                                    >
                                                        <i className="bi bi-x-lg"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                    )}
                </div>
                <div className="dn-foot">
                    <span className="text-muted small">Showing {filteredRows.length ? startIndex + 1 : 0} to {Math.min(startIndex + itemsPerPage, filteredRows.length)} of {filteredRows.length} entries</span>
                    {totalPages > 1 && <div className="dn-pager"><button disabled={currentPage === 1} onClick={() => setCurrentPage((page) => page - 1)}>‹</button>{Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => <button key={page} className={page === currentPage ? "active" : ""} onClick={() => setCurrentPage(page)}>{page}</button>)}<button disabled={currentPage === totalPages} onClick={() => setCurrentPage((page) => page + 1)}>›</button></div>}
                </div>
            </div>
        </div>
    );
}
